import { action, computed, makeObservable, observable } from 'mobx';

import { User } from '../../app/entities';

class AuthStore {
  private _currentUser: User | null = null;
  isAuthorized = true;

  constructor() {
    makeObservable(this, {
      isAuthorized: observable,
      setAuthorized: action,
      currentUser: computed,
    });
  }

  setAuthorized(isAuthorized: boolean) {
    this.isAuthorized = isAuthorized;
  }

  get currentUser(): User | null {
    if (!this._currentUser) {
      const users = User.getAll();
      if (users.length === 0) {
        return null;
      }

      this._currentUser = users[0];
    }

    return this._currentUser;
  }
}

export const authStore = new AuthStore();
